import { useState } from "react";
import { Disclosure } from "../../components/Disclosure";
import { FiltroArticulos, type TiposSeleccionFiltroStock } from "./components/FiltroArticulos";
import { IndicadoresCantidades } from "./components/IndicadoresCantidades";
import { TablaArticulos } from "./components/TablaArticulos";
import { TablaOrdenes } from "./components/TablaOrdenes";
import { Breadcrumb } from "../../components/Breadcrumb";

export function GestionArticulosPage() {
	const [filtroStock, setFiltroStock] = useState<TiposSeleccionFiltroStock>("todo");
	const [filtroFamilia, setFiltroFamilia] = useState<string[]>([]);
	const [filtroSubfamilia, setFiltroSubfamilia] = useState<string[]>([]);
	const [filtroTipoArticulo, setFiltroTipoArticulo] = useState<string[]>([]);

	return (
		<div id="content" className="content" >
			<title>Almacen | Gestión de Artículos</title>

			<Breadcrumb
				sectionTitle="Gestión de Artículos"
				links={[
					{ label: "Gestión de Artículos", active: true }
				]}
			/>

			<div className="box-shadow panel-box panel-info" style={{ display: "none" }}>
				<h4><strong>Info</strong></h4>
				Aquí podras encontrar un listado con información sobre la producción de ordenes de fabricación. Desde el botón + podras añadir una orden a la serie.
			</div>


			<Disclosure style={{ marginBottom: 20 }}>
				{/* First element is the summary, second is the content */}
				<h4 className="panel-title panel-heading senalar">
					Filtro
				</h4>
				<FiltroArticulos
					filtroStock={filtroStock}
					setFiltroStock={setFiltroStock}

					familia={filtroFamilia}
					setFamilia={setFiltroFamilia}

					subfamilia={filtroSubfamilia}
					setSubfamilia={setFiltroSubfamilia}

					tipoArticulo={filtroTipoArticulo}
					setTipoArticulo={setFiltroTipoArticulo}
				/>
			</Disclosure>

			<IndicadoresCantidades
				familia={filtroFamilia}
				subfamilia={filtroSubfamilia}
				setFiltroStock={setFiltroStock}
			/>

			<div>
				<h1 style={{ marginBottom: 0 }}> Artículos </h1>
				<TablaArticulos
					familia={filtroFamilia}
					subfamilia={filtroSubfamilia}
					stock={filtroStock}
					tipoArticulo={filtroTipoArticulo}
				/>
			</div>

			<div id="datatableOrdenes">
				<h1 style={{ marginBottom: 0 }}> Ordenes de Fabricacion </h1>
				<TablaOrdenes
					familia={filtroFamilia}
					subfamilia={filtroSubfamilia}
				/>
			</div>
		</div>
	);
}